<template>
  <div
    :style="`${customStyles}`"
    :class="{
      'custom-button': true,
      'custom-button-small': size === 'small',
      'custom-button-large': size === 'large',
      'custom-button-gradient': gradient,
      'custom-button-disabled': disabled,
      gray: gray,
      white: white,
      pink: pink,
      radius: radius,
    }"
    @click="emitClick"
  >
    <p>{{ title }}</p>
  </div>
</template>

<script>
export default {
  props: [
    "disabled",
    "title",
    "size",
    "gradient",
    "customStyles",
    "gray",
    "white",
    "radius",
    "pink",
  ],
  emits: ["click"],
  methods: {
    emitClick() {
      if (!this.disabled) {
        this.$emit("click");
      }
    },
  },
};
</script>

<style scoped>
.custom-button {
  width: 292px;
  height: 47px;
  border: 2px hidden #090741;
  background: #090741;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  margin-top: 10px;
  transition: 0.5s all;
}
.custom-button:hover {
  background: rgb(251, 134, 42);
  background: linear-gradient(
    90deg,
    rgba(251, 134, 42, 1) 0%,
    rgba(241, 76, 82, 1) 49%,
    rgba(229, 8, 129, 1) 100%
  );
  border: 2px hidden transparent;
}
.custom-button-gradient {
  background: rgb(251, 134, 42);
  background: linear-gradient(
    90deg,
    rgba(251, 134, 42, 1) 0%,
    rgba(241, 76, 82, 1) 49%,
    rgba(229, 8, 129, 1) 100%
  );
  border: none;
}
.custom-button-gradient:hover {
  background: rgb(251, 134, 42);
  background: linear-gradient(
    90deg,
    rgba(251, 134, 42, 1) 0%,
    rgba(241, 76, 82, 1) 49%,
    rgba(229, 8, 129, 1) 100%
  );
  border: none;
  color: #fff;
}
.custom-button p {
  width: 100%;
  height: 100%;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  text-align: center;
  display: grid;
  place-items: center;
}
.custom-button-large p {
  text-transform: uppercase;
}
.custom-button-small {
  padding: 4px 0px;
  gap: 10px;
  width: 141px;
  height: 32px;
  border-radius: 5px;
}
.custom-button-small p {
  font-weight: 400;
  font-size: 13px;
}
.gray {
  background: rgba(9, 7, 65, 0.05);
  border: 2px hidden transparent;
  color: rgba(9, 7, 65);
}
.white {
  background: white;
  color: rgba(9, 7, 65);
  border: 1px hidden rgba(9, 7, 65);
}
.pink {
  background: #e2037e;
  color: white;
  border: unset;
}
.white:hover {
  color: white;
  background: rgba(9, 7, 65);
}
.gray:hover {
  background: rgba(9, 7, 65, 0.05);
}
.radius {
  border-radius: 20px;
}
.custom-button-disabled {
  background-color: #d3d3d3;
  color: black;
  cursor: not-allowed !important;
  pointer-events: none;
  opacity: 0.6;
}
</style>
